import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { useSiteSettings } from '../context/SiteSettingsContext';

const Footer = () => {
  const { getSetting } = useSiteSettings();

  const phone = getSetting('phone', '0693526449');
  const formattedPhone = phone.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');

  return (
    <footer className="footer-dark" data-testid="main-footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <span 
              className="text-2xl font-bold tracking-tight block mb-4"
              style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
            >
              {getSetting('company_name', 'IDMAT').replace('Service', '')}<span style={{ color: '#F5C500' }}>SERVICE</span>
            </span>
            <p className="text-gray-400 mb-6 leading-relaxed">
              {getSetting('footer_description', 'Votre expert en réparation et peinture d\'engins de chantier à La Réunion.')}
            </p>
            <a 
              href={getSetting('footer_idmatoi_link', 'https://idmatoi.com')}
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block text-[#F5C500] hover:underline"
              data-testid="idmatoi-link"
            >
              Achetez vos engins LiuGong sur idmatoi.com →
            </a>
          </div>

          {/* Navigation */}
          <div>
            <h4 
              className="text-lg font-bold mb-6 text-white"
              style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
            >
              Navigation
            </h4>
            <nav className="flex flex-col gap-3">
              <Link to="/" className="text-gray-400 hover:text-[#F5C500] transition-colors">
                Accueil
              </Link>
              <Link to="/reparation" className="text-gray-400 hover:text-[#F5C500] transition-colors">
                Réparation
              </Link>
              <Link to="/peinture" className="text-gray-400 hover:text-[#F5C500] transition-colors">
                Peinture
              </Link>
              <Link to="/entretien" className="text-gray-400 hover:text-[#F5C500] transition-colors">
                Entretien
              </Link>
              <Link to="/prestations" className="text-gray-400 hover:text-[#F5C500] transition-colors">
                Prestations
              </Link>
              <Link to="/contact" className="text-gray-400 hover:text-[#F5C500] transition-colors">
                Contact & Devis
              </Link>
            </nav>
          </div>

          {/* Services */}
          <div>
            <h4 
              className="text-lg font-bold mb-6 text-white"
              style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
            >
              Nos Services
            </h4>
            <ul className="flex flex-col gap-3 text-gray-400">
              <li>Réparation mécanique</li>
              <li>Peinture d'engins</li>
              <li>Entretien préventif</li>
              <li>Diagnostic hydraulique</li>
              <li>Remplacement de pièces</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 
              className="text-lg font-bold mb-6 text-white"
              style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
            >
              Contact
            </h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <MapPin size={20} className="text-[#F5C500] flex-shrink-0 mt-1" />
                <span className="text-gray-400">
                  {getSetting('address', '27 avenue des artisans')}<br />
                  {getSetting('city', '97436 Saint-Leu')}<br />
                  {getSetting('region', 'La Réunion')}
                </span>
              </div>
              <a 
                href={`tel:${phone}`}
                className="flex items-center gap-3 text-gray-400 hover:text-[#F5C500] transition-colors"
                data-testid="footer-phone"
              >
                <Phone size={20} className="text-[#F5C500]" />
                {formattedPhone}
              </a>
              <a 
                href={`mailto:${getSetting('email', 'contact@idmatoi.com')}`}
                className="flex items-center gap-3 text-gray-400 hover:text-[#F5C500] transition-colors"
                data-testid="footer-email"
              >
                <Mail size={20} className="text-[#F5C500]" />
                {getSetting('email', 'contact@idmatoi.com')}
              </a>
              <div className="flex items-center gap-3 text-gray-400">
                <Clock size={20} className="text-[#F5C500]" />
                {getSetting('hours', 'Lun - Ven : 07h00 - 16h00')}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {new Date().getFullYear()} {getSetting('company_name', 'IDMAT Service')}. Tous droits réservés. | Zone d'intervention : Toute l'île de La Réunion
            </p>
            <div className="flex items-center gap-4 text-sm text-gray-500">
              <span>Marques : {getSetting('footer_brands', 'LiuGong • Komatsu • Caterpillar • Kubota')}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
